export const getDefaultSettings = () => {
  return {
    aboveQrCodeImg: {
      img: undefined,
      height: 'auto',
      width: '200',
      align: 'center',
    },
    aboveTextSettings: {
      text: '',
      align: 'center',
    },
    belowQrCodeImg: {
      img: undefined,
      height: 'auto',
      width: '200',
      align: 'center',
    },
    belowTextSettings: {
      text: '',
      align: 'center',
    },
    vehicleTitle: {
      selectedVehicleTitles: [],
      displayCarVin: true,
      displayStockNumber: true,
      align: 'center',
    },
    typography: {
      markupTextColor: '',
      markupFontSize: '20',
      markupFontSizeUnit: 'px',
      markupLineHeight: '',
      markupLineHeightUnit: '',
      markupTextWeight: '',
    },
  }
}
